export type DocumentsActions = FilterDocuments | ResetDocumentsActions;

export const FILTER_DOCUMENTS = 'FILTER_DOCUMENTS' as const;
export const filterDocuments = () => ({
  type: FILTER_DOCUMENTS,
});
export type FilterDocuments = ReturnType<typeof filterDocuments>;

export type ResetDocumentsActions = ResetDocumentsForm;

export const RESET_FILTER_DOCUMENTS = 'RESET_FILTER_DOCUMENTS' as const;
export const resetDocumentsForm = () => ({
  type: RESET_FILTER_DOCUMENTS,
});
export type ResetDocumentsForm = ReturnType<typeof resetDocumentsForm>;
